import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageAPL6 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "France U23s lose to England U23s",
            author: "footballgirl",
              date: "Fevrier, 2026",
            image: "images/apl/6a.jpg",
             content: `<h2>Match Overview</h2>
<p>England's Women's U23 team beat France U23s 1-0 in a Women's U23 European Competition fixture at Clairefontaine, France's national training center. This result helped England secure a semi-final spot in the competition (details on opponents to be confirmed, with semis in Spain in April).</p>

<h2>Key Moment and Goal</h2>
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
<p>The win, thanks to a first-half strike from Lexi Lloyd-Smith, helped the Young Lionesses clinch a semi-final place in the competition (opposition and exact dates to be confirmed, with the semi-finals scheduled for April).</p>

<h2>Match Report</h2>
<p>The closely contested game saw England dominate early chances, with Erica Meg Parkinson hitting the inside of the post from a solo run. Lloyd-Smith (Bristol City) then broke the deadlock in the 43rd minute, recycling a loose ball on the right side of the penalty area before unleashing an unstoppable shot past France goalkeeper Ines Marques into the top corner. France pushed hard after the break but England’s defence stood firm. Debutant/full starter Megan Collett (Southampton) nearly added a second when her effort from a corner hit the outside of the post. Interim head coach Lauren Smith’s side kept a clean sheet to start 2026 on a high note.</p>

<h2>Implications for Both Teams</h2>
<p>For France's youth pathway (a key feeder for Les Bleues), it was a setback in their group campaign. This ties into broader French women's football development, as many U23 talents are eyed for senior call-ups or club breakthroughs in the Arkema Première Ligue. The match was part of England's preparation window before their next fixture against the Netherlands.</p>
<h3>英格兰U23女足在克莱枫丹以1-0击败法国U23女足</h3>

<h2>比赛概览</h2>
<p>英格兰U23女足在法国国家训练中心克莱枫丹举行的U23女足欧洲联赛比赛中，以1-0击败法国U23女足。这一结果帮助英格兰锁定半决赛席位（对手详情待确认，半决赛将于4月在西班牙举行）。</p>

<h2>关键进球</h2>
<p>这场胜利得益于上半场Lexi Lloyd-Smith的进球，帮助年轻狮子军锁定半决赛席位（对手和确切日期待确认，半决赛定于4月举行）。</p>

<h2>比赛报告</h2>
<p>这场势均力敌的比赛中，英格兰在上半场占据先机，Erica Meg Parkinson单刀突入禁区射门击中门柱内侧弹出。Lexi Lloyd-Smith（布里斯托尔城）随后在第43分钟打破僵局，她在禁区右侧回收失球后，轰出一记势大力沉的射门，球越过法国门将Ines Marques直入球门死角。下半场法国队全力反扑，但英格兰防线稳固。首次首发的Megan Collett（南安普顿）差点再下一城，她的角球进攻射门击中门柱外侧。临时主帅Lauren Smith的球队零封对手，以干净利落的胜利开启2026年。</p>

<h2>对两队的意义</h2>
<p>对于法国青年培养体系（Les Bleues的重要人才输送渠道）而言，这是小组赛阶段的一次挫折。这与法国女子足球整体发展相关，许多U23球员正被寄予厚望，期待进入成年国家队或在Arkema Première Ligue俱乐部取得突破。本场比赛也是英格兰在下一场对阵荷兰的比赛前的备战窗口。</p>`,
           tags: ["france", "England", "U23", "Clairefontaine"],
            readingTime: "6 min read",  
            navIndices: { prev: 'apl-5', next: 'apl-7' }
        });
    }

    init() {
        console.log('ArticlePageAPL6 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to APL
            `;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'apl' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_apl.png';
            leagueLogo.alt = 'APL';
        }
    }
}